<template>
  <div class="tickets-list-wrapper">
    <status-filter @change="handleFilterChange" />
    <orders-group
      :items="orders"
      :spotTitle="spotTitle"
      :loading="loading"
      :finished="finished"
      @load="handleLoad"
      @refund="handleRefund"
    />
    <!-- <global-tabbar/> -->
  </div>
</template>
<script>
import { getOrders, createRefund } from '@/api/api-user';
import { handelWeChatConfig } from '@/utils/util';

// import GlobalTabbar from '@/components/GlobalTabbar.vue';
import StatusFilter from './StatusFilter';
import OrdersGroup from './OrdersGroup';

export default {
  name: 'OrdersList',
  components: {
    // GlobalTabbar,
    StatusFilter,
    OrdersGroup,
  },
  data() {
    return {
      page: 1,
      status: 0,
      orders: [],
      spotTitle: '',
      loading: false,
      finished: false,
    };
  },
  async created() {
    try {
      await this.handleLoad();
      await this.handleInit();
    } catch (error) {}
  },
  methods: {
    handleInit() {
      handelWeChatConfig({ title: this.spotTitle, desc: '我的订单' });
    },
    handleFilterChange(status) {
      this.page = 1;
      this.status = status;
      this.orders = [];
      this.finished = false;
      this.handleLoad();
    },
    async handleLoad() {
      this.loading = true;
      const { status, page } = this;
      const orders = await getOrders({ status, page });
      this.loading = false;
      this.page += 1;
      this.spotTitle = orders.spot_title;
      this.orders = [...this.orders, ...orders.list];
      if (orders.count <= this.orders.length) {
        this.finished = true;
      }
    },
    async handleRefund(code, spotId) {
      const refund = await createRefund({ code, spotId });
      if (refund) {
        this.$toast.success('申请提交成功，请等待审核');
        this.handleFilterChange(this.status);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tickets-list-wrapper {
  display: relative;
  padding-top: 46px;
  // padding-bottom: 50px;
  margin-bottom: 50px;
}
</style>
